import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from "react-redux";
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import { getstudentFeedback, deletestudentFeedbacks,updatefeedback } from '../../ReduxToolkit/Slice/Feedback/StudentFeedback';


function StudentFeedback() {
    const dispatch = useDispatch();
    const { status, studentFeedbacks } = useSelector((state) => state.studentFeedback);
    //  get
    useEffect(() => {
        if (status === "idle") {
            dispatch(getstudentFeedback())
        }
    }, [dispatch, status]);
    // delete api
    const handleDelete = (studentFeedbackid) => {
        const Isconfirmed = window.confirm("Are you sure! you want delete this Feedback?")
        if (Isconfirmed) {
            dispatch(deletestudentFeedbacks(studentFeedbackid))
        };
    }
    // single data fetch
    const [email, setEmail] = useState(null);
    const [name, setName] = useState("");
    const [year, setYear] = useState("");
    const [programme, setProgramme] = useState("");
    const [batch, setBatch] = useState("");
    const [question1, setQuestion1] = useState("");
    const [question2, setQuestion2] = useState("");
    const [question3, setQuestion3] = useState("");
    const [question4, setQuestion4] = useState("");
    const [question5, setQuestion5] = useState("");
    const [question6, setQuestion6] = useState("");
    const [question7, setQuestion7] = useState("");
    const [question8, setQuestion8] = useState("");
    const [question9, setQuestion9] = useState("");
    const [question10, setQuestion10] = useState("");
    const [question11, setQuestion11] = useState("");
    const [question12, setQuestion12] = useState("");
    const [question13, setQuestion13] = useState("");
    const [question14, setQuestion14] = useState("");
    const [question15, setQuestion15] = useState("");
    const [question16, setQuestion16] = useState("");
    const [question17, setQuestion17] = useState("");
    const [question18, setQuestion18] = useState("");
    const [question19, setQuestion19] = useState("");
    const [question20, setQuestion20] = useState("");
    const [suggestion, setSuggestion] = useState("");
    const [selectedId, setSelectedId] = useState(null);
    const handlid = (id) => {
        const selectedStudentFeedback = studentFeedbacks.data.find(studentFeedback => studentFeedback._id === id);
        setEmail(selectedStudentFeedback.email);
        setName(selectedStudentFeedback.name);
        setYear(selectedStudentFeedback.year);
        setProgramme(selectedStudentFeedback.programme);
        setBatch(selectedStudentFeedback.batch);
        setQuestion1(selectedStudentFeedback.question1);
        setQuestion2(selectedStudentFeedback.question2);
        setQuestion3(selectedStudentFeedback.question3);
        setQuestion4(selectedStudentFeedback.question4);
        setQuestion5(selectedStudentFeedback.question5);
        setQuestion6(selectedStudentFeedback.question6);
        setQuestion7(selectedStudentFeedback.question7);
        setQuestion8(selectedStudentFeedback.question8);
        setQuestion9(selectedStudentFeedback.question9);
        setQuestion10(selectedStudentFeedback.question10);
        setQuestion11(selectedStudentFeedback.question11);
        setQuestion12(selectedStudentFeedback.question12);
        setQuestion13(selectedStudentFeedback.question13);
        setQuestion14(selectedStudentFeedback.question14);
        setQuestion15(selectedStudentFeedback.question15);
        setQuestion16(selectedStudentFeedback.question16);
        setQuestion17(selectedStudentFeedback.question17);
        setQuestion18(selectedStudentFeedback.question18);
        setQuestion19(selectedStudentFeedback.question19);
        setQuestion20(selectedStudentFeedback.question20);
        setSuggestion(selectedStudentFeedback.suggestion);
        setSelectedId(id);
    };
    // update
    const toggleSupportStatus = async (id) => {
        const feedbackToToggle = studentFeedbacks.data.find(feedback => feedback._id === id);
        if (!feedbackToToggle) return;
        const updatedStatus = !feedbackToToggle.status;
        const data = { status: updatedStatus };
        await dispatch(updatefeedback({ id, data }));
    };
    return (
        <>
            <div>
                <div className='d-flex justify-content-between my-3'>
                    <h3>StudentFeedbacks </h3>
                </div>
                <div className='table-responsive'>
                    <table className="table table-hover">
                        <thead className="table-primary">
                            <tr>
                                <th scope="col">S.no</th>
                                <th scope="col">Name</th>
                                <th scope="col">Email</th>
                                <th scope="col">Programme</th>
                                <th scope="col">Batch</th>
                                <th scope="col">Year</th>
                                <th scope="col">date</th>
                                <th scope="col">Status</th>
                                <th scope="col">Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {status === "loading" && (
                                <tr className='my-2'>
                                    <td colSpan={9}>
                                        <Skeleton count={10} height={90} />
                                    </td>
                                </tr>
                            )}
                            {status === "failed" && (
                                <tr>
                                    <td colSpan={9}>
                                        <p className='text-center fw-bold'>{"Data not found"}</p>
                                    </td>
                                </tr>
                            )}
                            {status === "succeeded" && studentFeedbacks.data && studentFeedbacks.data.map((studentFeedback, index) => {
                                const newdate = new Date(studentFeedback.createdAt);
                                const formattedDate = newdate.toLocaleDateString("default", {
                                    day: "2-digit",
                                    month: "long",
                                    year: "numeric"
                                });
                                return (
                                    <tr key={studentFeedback._id}>
                                        <th scope="row">{index + 1}</th>
                                        <td>{studentFeedback.name}</td>
                                        <td>{studentFeedback.email}</td>
                                        <td>{studentFeedback.programme}</td>
                                        <td>{studentFeedback.batch}</td>
                                        <td>{studentFeedback.year}</td>
                                        <td>{formattedDate}</td>
                                        <td className='cursor' onClick={()=>toggleSupportStatus(studentFeedback._id)}>{studentFeedback.status ? <span className='bg-success px-2 rounded text-white'>Approved</span> : <span className='bg-warning px-2 rounded'>Pending</span>}</td>
                                        <td className='cursor'>
                                            <div onClick={() => handlid(studentFeedback._id)}><i className='bi bi-eye-fill text-primary fs-5' data-bs-toggle="modal" data-bs-target="#exampleModal"></i></div>
                                            <div onClick={() => handleDelete(studentFeedback._id)}><i className='bi bi-trash text-danger fs-5'></i></div>
                                        </td>
                                    </tr>
                                )
                            })}
                        </tbody>
                    </table>
                </div>
            </div>

            {/* Modal  */}
            <div
                className="modal fade"
                id="exampleModal"
                tabIndex={-1}
                aria-labelledby="exampleModalLabel"
                aria-hidden="true"
            >
                <div className="modal-dialog modal-xl modal-dialog-scrollable">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h1 className="modal-title fs-5" id="exampleModalLabel">
                                Student Feedback
                            </h1>
                            <button
                                type="button"
                                className="btn-close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                            />
                        </div>
                        <div className="modal-body">
                            <div className="row">
                                <div className="col-12 col-lg-4 mb-3">
                                    <div>
                                        <h6>Name</h6>
                                        <h6 className='text-primary'>{name}</h6>
                                    </div>
                                </div>
                                <div className="col-12 col-lg-4 mb-3">
                                    <div>
                                        <h6>Email</h6>
                                        <h6 className='text-primary'>{email}</h6>
                                    </div>
                                </div>
                                <div className="col-12 col-lg-4 mb-3">
                                    <div>
                                        <h6>Programme</h6>
                                        <h6 className='text-primary'>{programme}</h6>
                                    </div>
                                </div>
                                <div className="col-12 col-lg-4 mb-3">
                                    <div>
                                        <h6>Batch</h6>
                                        <h6 className='text-primary'>{batch}</h6>
                                    </div>
                                </div>
                                <div className="col-12 col-lg-4 mb-3">
                                    <div>
                                        <h6>Year</h6>
                                        <h6 className='text-primary'>{year}</h6>
                                    </div>
                                </div>
                                <div className="col-12 col-lg-12 mb-3">
                                    <div>
                                        <h6>1 .The curriculum is up-to-date, need based and application oriented.</h6>
                                        <h6 className='text-primary'><i className='bi bi-circle-fill text-primary' style={{ fontSize: "10px" }}></i> {question1}</h6>
                                    </div>
                                </div>
                                <div className="col-12 col-lg-12 mb-3">
                                    <div>
                                        <h6>2 .The curriculum provide scope for acquiring strong knowledge and intellectual growth..</h6>
                                        <h6 className='text-primary'><i className='bi bi-circle-fill text-primary' style={{ fontSize: "10px" }}></i> {question2}</h6>
                                    </div>
                                </div>
                                <div className="col-12 col-lg-12 mb-3">
                                    <div>
                                        <h6>3 .The curriculum enables rich practical experience in the clinicals and labs for enhancement of knowledge and skills..</h6>
                                        <h6 className='text-primary'><i className='bi bi-circle-fill text-primary' style={{ fontSize: "10px" }}></i> {question3}</h6>
                                    </div>
                                </div>
                                <div className="col-12 col-lg-12 mb-3">
                                    <div>
                                        <h6>4 .The curriculum facilitates development of analytical and problem-solving skill.</h6>
                                        <h6 className='text-primary'><i className='bi bi-circle-fill text-primary' style={{ fontSize: "10px" }}></i> {question4}</h6>
                                    </div>
                                </div>
                                <div className="col-12 col-lg-12 mb-3">
                                    <div>
                                        <h6>5 .The curriculum inculcates soft skills including communication skill.</h6>
                                        <h6 className='text-primary'><i className='bi bi-circle-fill text-primary' style={{ fontSize: "10px" }}></i> {question5}</h6>
                                    </div>
                                </div>
                                <div className="col-12 col-lg-12 mb-3">
                                    <div>
                                        <h6>6 .Assignment/ Projects given are relevant, useful and help in improving the understanding and application of the subject matter throughout the curriculum.</h6>
                                        <h6 className='text-primary'><i className='bi bi-circle-fill text-primary' style={{ fontSize: "10px" }}></i> {question6}</h6>
                                    </div>
                                </div>
                                <div className="col-12 col-lg-12 mb-3">
                                    <div>
                                        <h6>7 .Curriculum is enriched with diverse teaching learning methods like lecture method, panel discussion, class discussion, etc. for good learning outcomes.</h6>
                                        <h6 className='text-primary'><i className='bi bi-circle-fill text-primary' style={{ fontSize: "10px" }}></i> {question7}</h6>
                                    </div>
                                </div>
                                <div className="col-12 col-lg-12 mb-3">
                                    <div>
                                        <h6>8 .Participation in learning strategies like seminar, workshop, conference and research project, etc promotes sense of responsibility.</h6>
                                        <h6 className='text-primary'><i className='bi bi-circle-fill text-primary' style={{ fontSize: "10px" }}></i> {question8}</h6>
                                    </div>
                                </div>
                                <div className="col-12 col-lg-12 mb-3">
                                    <div>
                                        <h6>9 .The curriculum provides opportunity for co- curricular activities.</h6>
                                        <h6 className='text-primary'><i className='bi bi-circle-fill text-primary' style={{ fontSize: "10px" }}></i> {question9}</h6>
                                    </div>
                                </div>
                                <div className="col-12 col-lg-12 mb-3">
                                    <div>
                                        <h6>10 .The curriculum is effective in developing human/social values and professional ethics required for organization.</h6>
                                        <h6 className='text-primary'><i className='bi bi-circle-fill text-primary' style={{ fontSize: "10px" }}></i> {question10}</h6>
                                    </div>
                                </div>
                                <div className="col-12 col-lg-12 mb-3">
                                    <div>
                                        <h6>11 .The syllabus and learning material of curriculum are adequate in terms of quality.</h6>
                                        <h6 className='text-primary'><i className='bi bi-circle-fill text-primary' style={{ fontSize: "10px" }}></i> {question11}</h6>
                                    </div>
                                </div>
                                <div className="col-12 col-lg-12 mb-3">
                                    <div>
                                        <h6>12 .Library is well equipped in terms of computerized infrastructure and electronic standard software.</h6>
                                        <h6 className='text-primary'><i className='bi bi-circle-fill text-primary' style={{ fontSize: "10px" }}></i> {question12}</h6>
                                    </div>
                                </div>
                                <div className="col-12 col-lg-12 mb-3">
                                    <div>
                                        <h6>13 .Textbooks and reference material recommended in the syllabus are relevant and updated.</h6>
                                        <h6 className='text-primary'><i className='bi bi-circle-fill text-primary' style={{ fontSize: "10px" }}></i> {question13}</h6>
                                    </div>
                                </div>
                                <div className="col-12 col-lg-12 mb-3">
                                    <div>
                                        <h6>14 .Teaching learning process enables clear understanding of the course content.</h6>
                                        <h6 className='text-primary'><i className='bi bi-circle-fill text-primary' style={{ fontSize: "10px" }}></i> {question14}</h6>
                                    </div>
                                </div>
                                <div className="col-12 col-lg-12 mb-3">
                                    <div>
                                        <h6>15 .Methods and criteria of assessment and grading are clearly communicated before the commencement of the term/ semester.</h6>
                                        <h6 className='text-primary'><i className='bi bi-circle-fill text-primary' style={{ fontSize: "10px" }}></i> {question15}</h6>
                                    </div>
                                </div>
                                <div className="col-12 col-lg-12 mb-3">
                                    <div>
                                        <h6>16 .Examinations are conducted in a fair, disciplined and organized manner.</h6>
                                        <h6 className='text-primary'><i className='bi bi-circle-fill text-primary' style={{ fontSize: "10px" }}></i> {question16}</h6>
                                    </div>
                                </div>
                                <div className="col-12 col-lg-12 mb-3">
                                    <div>
                                        <h6>17 .The curriculum follows fair assessment and evaluation process for grading.</h6>
                                        <h6 className='text-primary'><i className='bi bi-circle-fill text-primary' style={{ fontSize: "10px" }}></i> {question17}</h6>
                                    </div>
                                </div>
                                <div className="col-12 col-lg-12 mb-3">
                                    <div>
                                        <h6>18 .Guidance and counseling for academic improvement are involved in curriculum.</h6>
                                        <h6 className='text-primary'><i className='bi bi-circle-fill text-primary' style={{ fontSize: "10px" }}></i> {question18}</h6>
                                    </div>
                                </div>
                                <div className="col-12 col-lg-12 mb-3">
                                    <div>
                                        <h6>19 .TClinical practise and assignment like demostration, health education and case study enhance practical skills.</h6>
                                        <h6 className='text-primary'><i className='bi bi-circle-fill text-primary' style={{ fontSize: "10px" }}></i> {question19}</h6>
                                    </div>
                                </div>
                                <div className="col-12 col-lg-12 mb-3">
                                    <div>
                                        <h6>20 .Integration of value added and add on courses increase scope of job opportunity.</h6>
                                        <h6 className='text-primary'><i className='bi bi-circle-fill text-primary' style={{ fontSize: "10px" }}></i> {question20}</h6>
                                    </div>
                                </div>
                                <div className="col-12 col-lg-12 my-3 border rounded py-2">
                                    <div>
                                        <h6>SUGGESTIONS</h6>
                                        <p>{suggestion}</p>
                                    </div>
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button
                                    type="button"
                                    className="btn btn-secondary"
                                    data-bs-dismiss="modal"
                                >
                                    Close
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default StudentFeedback;
